import { render, staticRenderFns } from "./Donaciones.vue?vue&type=template&id=3c6525d9&scoped=true&"
import script from "./Donaciones.vue?vue&type=script&lang=js&"
export * from "./Donaciones.vue?vue&type=script&lang=js&"
import style0 from "./Donaciones.vue?vue&type=style&index=0&id=3c6525d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6525d9",
  null
  
)

/* custom blocks */
import block0 from "./data/donaciones.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Flib%2Fjenkins%2Fworkspace%2Fgrupo-vid%2Fportal-pagos%2Fnpm_build_portal-pagos-web_production%2Fportal-pagos-vid-web%2Fsrc%2Fcomponents%2Fview%2Ffrontoffice%2Fpublic%2Fdonaciones%2FDonaciones.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCheckbox,VCol,VContainer,VForm,VImg,VRow,VTextField})
